import { yupResolver } from '@hookform/resolvers/yup';
import React, { forwardRef } from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';
import Divider from '../../../../../../components/Divider';
import Form from '../../../../../../components/Form';
import Paper from '../../../../../../components/Paper';
import Rating from '../../../../../../components/Rating';
import Typography from '../../../../../../components/Typography';
import { makeStyles } from '../../../../../../utils/styles';
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import { FORM } from '../../../../../../utils/constans';
import Icon from '../../../../../../components/Icon';
import useTheme from '../../../../../../hooks/useTheme';
import IconWrap from '../../../../../../components/IconWrap';
import { MessagesStyled, MessageStyled, TextStyled } from './styled';
import Avatar from '../../../../../../components/Avatar';
import JobShortDesc from '../../../../components/JobShortDesc';
import ScrollArea from '../../../../../../components/ScrollArea';
import FormLabel from '../../../../../../components/FormLabel';
import Loader from '../../../../../../components/Loader';
import IconButton from '../../../../../../components/IconButton';
import FormError from '../../../../../../components/FormError';
import TextArea from '../../../../../../components/TextArea';
import { format } from 'date-fns';
import administratorAvatar from '../../../../../../assets/images/administrator-avatar.png';
import { getImageUrl } from '../../../../../../utils/helpers';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(css => ({
    paper: css`
        position: relative;
        overflow: hidden;
    `,
    dividerHeader: css`
        margin-top: 15px;
    `,
    dividerHeaderTwo: css`
        margin-top: 10px;
    `,
    jobShortDesc: css`
        margin-bottom: 10px;
    `,
    icon: css`
        margin: 0 10px;
    `,
    name: css`
        font-size: 14px;
        line-height: 20px;
    `,
    date: css`
        font-size: 10px;
        line-height: 12px;
    `,
    form: css`
        position: relative;
    `,
    textarea: css`
        margin-bottom: 0;
    `,
    errorLabel: css`
        position: absolute;
        top: 100%;
        left: 0;
        margin-top: 4px;
    `,
    formLabel: css`
        margin-top: 10px;
    `
}));

const schema = yup.object().shape({
    message: yup.string().required(FORM.FIELD_IS_REQUIRED)
});

const ChatContent = forwardRef(({ user, messages, isMoreMessages, isNoMessages, showLoader, loading, disabled, onScroll, onSubmit }, ref) => {
    const { t } = useTranslation()
    const styles = useStyles();
    const theme = useTheme();

    const { register, handleSubmit, errors, reset } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmitWithReset = onSubmit(reset);
    const submitMessage = handleSubmit(onSubmitWithReset);

    const handleKeyDown = e => {
        const keyCode = e.which || e.keyCode;
        if (keyCode === 13 && !e.shiftKey) {
            e.preventDefault();
            submitMessage();
        }
    };

    return (
        <Paper
            customStyle={styles.paper}
        >
            <Row between="xs" middle="xs">
                <Col>
                    <Typography as="h1">
                        {user?.username}
                    </Typography>
                </Col>
                <Col>
                    <Rating rate={user?.rankings} />
                </Col>
            </Row>
            <Divider customStyle={styles.dividerHeader} />
            {
                (!user?.isNewCandidate && user?.last_job) &&
                <>
                    <FormLabel customStyle={styles.formLabel}>{t("Nadchodzące zlecenie")}</FormLabel>
                    <JobShortDesc job={user?.last_job} customStyle={styles.jobShortDesc} />
                    <Divider customStyle={styles.dividerHeaderTwo} />
                </>
            }
            <ScrollArea
                heightModifiers={{
                    isCalc: true,
                    offset: 104
                }}
                onScroll={onScroll}
                ref={ref}
            >
                {
                    loading &&
                    <Typography align="center">{t("Ładowanie")}</Typography>
                }
                {
                    (!loading && !isNoMessages && !isMoreMessages) &&
                    <Typography align="center">{t("Nie ma więcej wiadomości")}</Typography>
                }
                {
                    (!loading && isNoMessages) &&
                    <Typography align="center">{t("Brak wiadomości")}</Typography>
                }
                <MessagesStyled>
                    {
                        (messages && messages.length > 0) && messages.map((message, index) => (
                            <MessageStyled
                                key={message?.id ?? index}
                                isAdmin={message?.from === "admin"}
                            >
                                <TextStyled isAdmin={message?.from === "admin"}>
                                    {message?.message}
                                </TextStyled>
                                <Row reverse={message.from === "admin"}>
                                    <Col>
                                        <Avatar
                                            src={message.from === "admin" ? administratorAvatar : getImageUrl(user.avatar?.url)}
                                            size="small"
                                        />
                                    </Col>
                                    <Col>
                                        {
                                            message?.from === "admin" &&
                                            <Typography customStyle={styles.name}>
                                                {t("Administrator")}
                                            </Typography>
                                        }
                                        {
                                            parseInt(message?.from, 10) === parseInt(user?.id, 10) &&
                                            <Typography customStyle={styles.name}>
                                                {user?.username ?? ""}
                                            </Typography>
                                        }
                                        {
                                            message?.created_at &&
                                            <Typography customStyle={styles.date}>{format(new Date(message?.created_at), 'dd.MM.yyyy, HH:mm')}</Typography>
                                        }
                                    </Col>
                                </Row>
                            </MessageStyled>
                        ))
                    }
                </MessagesStyled>
            </ScrollArea>
            <Form onSubmit={handleSubmit(onSubmitWithReset)} customStyle={styles.form}>
                <Row middle="xs">
                    <Col xs>
                        <TextArea
                            type="text"
                            ref={register}
                            name="message"
                            placeholder={t("Wiadomość")}
                            error={!!errors.message}
                            customStyle={styles.textarea}
                            fullWidth
                            rows={1}
                            onKeyDown={handleKeyDown}
                            disabled={disabled}
                        />
                    </Col>
                    <Col>
                        <IconButton
                            onClick={handleSubmit(onSubmitWithReset)}
                        >
                            <IconWrap customStyle={styles.icon}>
                                <Icon name="send" width={20} height={20} fill={theme.colors.darkGrey} />
                            </IconWrap>
                        </IconButton>
                    </Col>
                </Row>
                {
                    !!errors.message &&
                    <FormError
                        customStyle={styles.errorLabel}
                    >
                        {errors.message?.message}
                    </FormError>
                }
            </Form>
            <Loader show={showLoader} />
        </Paper>
    )
});

export default ChatContent;
